// Definir funciones globalmente de inmediato

document.addEventListener('DOMContentLoaded', function () {
  const allWrappers = document.querySelectorAll('.plp-swatches-wrapper');

  allWrappers.forEach(function (wrapper) {
    const conjuntoContainer = wrapper.querySelector('.plp-swatches[data-is-conjunto="true"]');

    if (conjuntoContainer) {
      const groupOneFirst = conjuntoContainer.querySelector('.plp-swatch[data-option-index="1"]:not(.disabled):not([disabled])');
      const groupTwoFirst = conjuntoContainer.querySelector('.plp-swatch[data-option-index="2"]:not(.disabled):not([disabled])');

      if (groupOneFirst) groupOneFirst.classList.add('active');
      if (groupTwoFirst) groupTwoFirst.classList.add('active');

      resolveConjuntoVariant(wrapper);
      return;
    }

    const buttons = wrapper.querySelectorAll('.plp-swatch:not(.disabled):not([disabled])');
    if (buttons.length > 0) {
      const firstButton = buttons[0];
      firstButton.classList.add('active');
      updateSelectedVariant(firstButton);
    }
  });
});

const plpProductVariantsCache = {};

function getHandleFromCard(cardWrapper, conjuntoContainer) {
  if (conjuntoContainer?.dataset?.productHandle) return conjuntoContainer.dataset.productHandle;

  const cardLink = cardWrapper?.querySelector('.card__heading a, .card__inner a.link__url');
  const href = cardLink?.getAttribute('href') || '';
  const match = href.match(/\/products\/([^/?#]+)/);
  if (match && match[1]) return match[1];

  return '';
}

async function getVariantsFromContainer(cardWrapper, conjuntoContainer) {
  if (!conjuntoContainer) return [];

  const productHandle = getHandleFromCard(cardWrapper, conjuntoContainer);
  if (!productHandle) return [];

  if (plpProductVariantsCache[productHandle]) {
    return plpProductVariantsCache[productHandle];
  }

  try {
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) return [];
    const productData = await response.json();
    const variants = (productData.variants || []).map((variant) => ({
      id: variant.id,
      option1: variant.option1,
      option2: variant.option2,
      available: variant.available
    }));
    plpProductVariantsCache[productHandle] = variants;
    return variants;
  } catch (error) {
    return [];
  }
}

async function resolveConjuntoVariant(wrapper) {
  const conjuntoContainer = wrapper.querySelector('.plp-swatches[data-is-conjunto="true"]');
  if (!conjuntoContainer) return null;

  const form = wrapper.closest('.card-wrapper, .grid__item')?.querySelector('.plp-add-form');
  if (!form) return null;

  const hiddenInput = form.querySelector('.selected-variant-id');
  const submitButton = form.querySelector('.plp-add-btn');
  const selectedOption1 = conjuntoContainer.querySelector('.plp-swatch[data-option-index="1"].active')?.dataset.optionValue;
  const selectedOption2 = conjuntoContainer.querySelector('.plp-swatch[data-option-index="2"].active')?.dataset.optionValue;
  const variants = await getVariantsFromContainer(wrapper.closest('.card-wrapper, .grid__item'), conjuntoContainer);

  const matchedVariant = variants.find(
    (variant) =>
      variant.option1 === selectedOption1 &&
      variant.option2 === selectedOption2 &&
      variant.available
  );

  if (hiddenInput) hiddenInput.value = matchedVariant ? matchedVariant.id : '';
  if (submitButton) submitButton.disabled = !matchedVariant;

  return matchedVariant || null;
}

window.updateSelectedVariant = async function(button) {
  const cardWrapper = button.closest('.card-wrapper') || button.closest('.grid__item');
  if (!cardWrapper) return;
  
  const form = cardWrapper.querySelector('.plp-add-form');
  if (!form) return;
  
  const hiddenInput = form.querySelector('.selected-variant-id');
  const submitButton = form.querySelector('.plp-add-btn');
  const swatchesContainer = button.closest('.plp-swatches');
  const isConjunto = swatchesContainer?.dataset?.isConjunto === 'true';

  if (isConjunto) {
    const optionIndex = button.dataset.optionIndex;
    const optionButtons = swatchesContainer.querySelectorAll(`.plp-swatch[data-option-index="${optionIndex}"]`);
    optionButtons.forEach((swatch) => swatch.classList.remove('active'));
    button.classList.add('active');
    await resolveConjuntoVariant(cardWrapper.querySelector('.plp-swatches-wrapper') || cardWrapper);
    return;
  }
  
  const swatches = swatchesContainer.querySelectorAll('.plp-swatch');
  
  swatches.forEach(s => s.classList.remove('active'));
  button.classList.add('active');
  
  hiddenInput.value = button.dataset.variantId;
  submitButton.disabled = false;
};

window.handleAddToCart = async function(event, button) {
  event.preventDefault();
  
  const form = button.closest('.plp-add-form');
  let variantId = form.querySelector('.selected-variant-id').value;
  const cardWrapper = button.closest('.card-wrapper') || button.closest('.grid__item');
  const conjuntoContainer = cardWrapper?.querySelector('.plp-swatches[data-is-conjunto="true"]');
  
  if (!variantId) {
    if (conjuntoContainer) {
      const resolved = await resolveConjuntoVariant(cardWrapper.querySelector('.plp-swatches-wrapper') || cardWrapper);
      if (resolved) {
        variantId = resolved.id;
      } else {
        return;
      }
    } else {
      const firstAvailableSwatch = cardWrapper.querySelector('.plp-swatch:not(.disabled)');
      if (firstAvailableSwatch) {
        variantId = firstAvailableSwatch.dataset.variantId;
        form.querySelector('.selected-variant-id').value = variantId;
      } else {
        return;
      }
    }
  }
  
  button.disabled = true;
  button.textContent = 'Agregando...';
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .then(() => {
    button.textContent = '¡Agregado!';
    
    fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        if (newDrawer) {
          const currentDrawer = document.querySelector('cart-drawer');
          if (currentDrawer) currentDrawer.outerHTML = newDrawer.outerHTML;
        }
        
        fetch(`${window.Shopify.routes.root}?section_id=cart-icon-bubble`)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newBubble = doc.querySelector('.shopify-section');
            if (newBubble) {
              const currentBubble = document.querySelector('#cart-icon-bubble');
              if (currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
            }
          });
        
        setTimeout(() => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }, 100);
      });
    
    setTimeout(() => {
      button.textContent = 'Agregar al carro';
      button.disabled = false;
    }, 1500);
  })
  .catch(() => {
    button.textContent = 'Error';
    setTimeout(() => {
      button.textContent = 'Agregar al carro';
      button.disabled = false;
    }, 1500);
  });
};